/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-expressions */

xplenty.directive('codeEditor', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/code-editor.html'),

      replace: true,

      scope: {
        options: '=',
        value: '=',
        editor: '=?',
        onChange: '&?',
        name: '@?',
      },

      require: '^?form',

      link(scope, element, attrs, formControl) {
        const $textarea = element.find('#code-editor');
        $textarea[0].value = scope.value;
        const form = formControl;

        const initEditor = function () {
          const oldCodeMirror = element.find('.CodeMirror')[0];

          if (oldCodeMirror) {
            oldCodeMirror.parentElement.removeChild(oldCodeMirror);
          }

          scope.editor = null;

          $timeout(function () {
            const defaultOptions = {
              lineWrapping: true,
              lineNumbers: true,
              mode: 'text/x-sql',
              placeholder: 'SELECT * FROM table',
            };

            const options = { ...defaultOptions, ...(scope.options || {}) };

            scope.editor = CodeMirror.fromTextArea($textarea[0], options);

            if (scope.value) scope.editor.setValue(scope.value);

            scope.editor.on('change', function (cm) {
              scope.value = cm.getValue();
              if (scope.name && form) {
                form[scope.name].$setTouched();
                form[scope.name].$setDirty();
              }
              angular.isFunction(scope.onChange) && scope.onChange({ value: scope.value });
              scope.$parent.$apply();

              $textarea[0].dispatchEvent(
                new Event('input', {
                  bubbles: true,
                  cancelable: true,
                }),
              );
            });

            scope.editor.on('blur', function (cm) {
              scope.value = cm.getValue();
              scope.$parent.$apply();
            });
          }, 1000);
        };

        scope.$watch('options', initEditor, true);
      },
    };
  },
]);
